import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../../components/common/Button';
import { Center } from '../../components/common/Center';
import { Stack } from '../../components/common/Stack';
import { useTranslation } from '../../I18nProvider';

type Props = {
  showButtons?: boolean;
  errorMessage?: string;
};

export function SoftwareErrorMessage({
  errorMessage,
  showButtons = true,
}: Props) {
  const t = useTranslation();
  const reload = () => window.location.reload();

  return (
    <Stack>
      <div>{errorMessage}</div>
      <Center></Center>
      {showButtons && (
        <Stack>
          <Button as={Link} variant="primary" to="../">
            {t.back}
          </Button>
          <Button variant="secondary" onClick={reload}>
            {t.reload}
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
